<template>
  <b-card
    no-body
    class="p-5 rounded-xl animated mb-3"
    :bg-variant="`${data.variant}`"
    style="min-width: 155px"
  >
    <div class="d-flex align-items-center">
      <i v-if="data.icon" :class="`${data.icon} font-size-h1`"></i>
      <div class="ml-4">
        <p class="font-size-h6 font-weight-bold mb-0">
          {{ data.title }}
          <i
            v-if="data.tooltip"
            v-b-tooltip="data.tooltip"
            class="ri-information-line"
          ></i>
        </p>
        <!-- spinner -->
        <b-spinner v-if="data.isLoading" />
        <div v-else>
          <number
            v-if="
              typeof data.value == 'number' ||
              (!isNaN(data.value) && data.value.trim() !== '')
            "
            :class="`font-size-${
              data.largeValue ? 'h2' : 'h3'
            } font-weight-bolder mb-0 ${data.valueClass || ''}`"
            tag="p"
            :from="0"
            :format="
              ($v) =>
                $options.filters.parse(
                  Math.floor($v),
                  data.transform || 'number'
                )
            "
            :to="data.value"
            :duration="3"
            easing="Circ.easeInOut"
          />
          <p
            v-else
            :class="`font-size-${
              data.largeValue ? 'h2' : 'h3'
            } font-weight-bolder mb-0 ${data.valueClass || ''}`"
          >
            {{ data.value }}
          </p>
          <b-badge v-if="data.subValue" variant="primary">{{
            data.subValue
          }}</b-badge>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "NurseryFeStatisticCard",

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/base/component/statistic-card.vue